<template>
    <div class="app-container">
        <el-tabs v-if="tableData.equipment" v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="设备信息" name="equipment">
                <h3><span style="vertical-align:text-top;">基本参数</span><el-button type="primary" plain size="small" @click.native="editEquipment()" style="width:60px;margin-left:20px;">编辑</el-button></h3>
                <table class="top-table" width="100%" border="1" cellpadding="20" cellspacing="0" bordercolor="#ebeef5">
                    <tr>
                        <td width="150" height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">设备别称</div></td>
                        <td colspan="3">&nbsp;&nbsp;{{tableData.equipment.eq_name}}</td>
                    </tr>
                    <tr>
                        <td width="150" height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">设备id</div></td>
                        <td>&nbsp;&nbsp;{{tableData.equipment.device_id}}</td>
                        <td width="150" bgcolor="#f5f7fa"><div align="center">设备序号</div></td>
                        <td>&nbsp;&nbsp;{{tableData.equipment.GRM}}</td>
                    </tr>
                    <tr>
                        <td height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">网络</div></td>
                        <td>&nbsp;&nbsp;{{tableData.equipment.is_internet}}</td>
                        <td bgcolor="#f5f7fa"><div align="center">信号</div></td>
                        <td>&nbsp;&nbsp;{{tableData.equipment.signal}}</td>
                    </tr>
                    <tr>
                        <td height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">设备开关</div></td>
                        <td>&nbsp;&nbsp;<el-switch v-model="tableData.equipment.switch" active-color="#13ce66" inactive-color="#c1c1c1" @change="equipmentSwitch(tableData.equipment.id)"></el-switch></td>
                        <td bgcolor="#f5f7fa"><div align="center">运行状态</div></td>
                        <td>&nbsp;&nbsp;{{tableData.equipment.running_state}}</td>
                    </tr>
                    <tr>
                        <td height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">安装时间</div></td>
                        <td>&nbsp;&nbsp;{{tableData.equipment.install_time}}</td>
                        <td bgcolor="#f5f7fa"><div align="center">上次维保时间</div></td>
                        <td>&nbsp;&nbsp;{{tableData.equipment.egis_time}}</td>
                    </tr><tr>
                        <td width="150" height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">设备说明书</div></td>
                        <td colspan="3">
                            <div v-for="(item, index) in tableData.equipment.thumb" :key="index">
                                <el-tooltip class="item" effect="dark" :content="item.filename" placement="top">
                                    <el-image v-if="item.ext == 'pdf'" style="width: 30px; height: 30px; margin-right: 10px;cursor:pointer" src="https://app.shengren.work/wanshuiqing/pdf.png" fit="cover" @click="openPDFVisible(item.path)"></el-image>
                                    <el-image v-else style="width: 30px; height: 30px; margin-right: 10px;cursor:pointer" :src="item.path" :preview-src-list="EsrcList" fit="cover"></el-image>
                                </el-tooltip>
                            </div>
                        </td>
                    </tr>
                </table>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <h3>项目信息</h3>
                <div class="upi-table">
                    <div class="upit-td">
                        <div class="upitt-label">项目编号</div>
                        <div class="upitt-value">{{tableData.project.item_number}}</div>
                    </div>
                    <div class="upit-td">
                        <div class="upitt-label">项目名称</div>
                        <div class="upitt-value">{{tableData.project.item_name}}</div>
                    </div>
                    <div class="upit-td">
                        <div class="upitt-label">项目地址</div>
                        <div class="upitt-value">{{tableData.project.proid}}{{tableData.project.cityid}}{{tableData.project.areaid}}{{tableData.project.address}}</div>
                    </div>
                    <div class="upit-td">
                        <div class="upitt-label">客户姓名</div>
                        <div class="upitt-value">{{tableData.project.realname}}</div>
                    </div>
                    <div class="upit-td">
                        <div class="upitt-label">客户联系方式</div>
                        <div class="upitt-value">{{tableData.project.tel}}</div>
                    </div>
                </div>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <h3><span style="vertical-align:text-top;">水质记录</span><el-button type="primary" plain size="small" @click="editWaterIndicators" style="width:auto;margin-left:20px;">查看全部记录</el-button></h3>
                <table class="top-table" width="100%" border="0" cellpadding="0" cellspacing="0" bordercolor="#ebeef5">
                    <tr>
                        <td valign="top" width="33.33333333333333%">
                            <table width="100%" border="1" cellpadding="20" cellspacing="0" bordercolor="#ebeef5">
                                <tr v-for="(item, key, index) in tableData.water_indicators" :key="index">
                                    <td v-if="index%3 === 0" width="150" height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">{{βwaterIndicatorsMap[key]}}</div></td>
                                    <td v-if="index%3 === 0">&nbsp;&nbsp;{{item}}</td>
                                </tr>
                            </table>
                        </td>
                        <td valign="top" width="33.33333333333333%">
                            <table width="100%" border="1" cellpadding="20" cellspacing="0" bordercolor="#ebeef5">
                                <tr v-for="(item, key, index) in tableData.water_indicators" :key="index">
                                    <td v-if="index%3 === 1" width="150" height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">{{βwaterIndicatorsMap[key]}}</div></td>
                                    <td v-if="index%3 === 1">&nbsp;&nbsp;{{item}}</td>
                                </tr>
                            </table>
                        </td>
                        <td valign="top" width="33.33333333333333%">
                            <table width="100%" border="1" cellpadding="20" cellspacing="0" bordercolor="#ebeef5">
                                <tr v-for="(item, key, index) in tableData.water_indicators" :key="index">
                                    <td v-if="index%3 === 2" width="150" height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">{{βwaterIndicatorsMap[key]}}</div></td>
                                    <td v-if="index%3 === 2">&nbsp;&nbsp;{{item}}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <h3>历史记录</h3>

                <div id="macarons" style="width: 98%; height: 510px;" ref="macarons"></div>

                <hr style="height:1px;border:none;border-top:1px solid #DCDFE6;margin:30px 0;" /> 
            
                <h3>现场图片</h3>
                <div class="demo-image__preview">
                    <div style="display: inline-block;position: relative;" v-for="(item, index) in tableData.eq_images" :key="index">
                        <el-image style="width: 148px; height: 148px" :src="item.path" :preview-src-list="srcList" fit="cover"></el-image>
                        <div style="position: absolute;left:0;right:0;text-align: center;color: #FFF;bottom: 10px;">{{item.remark}}</div>
                    </div>
                    <div style="display: inline-block;width: 148px; height: 148px;vertical-align: top;margin: 8px;">
                        <div class="upl-itme-icon" @click="openUploadPhoto">
                            <div class="icon"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M909.5 960.3H113c-27.5 0-49.8-22.3-49.8-49.8V114c0-27.5 22.3-49.8 49.8-49.8h796.5c27.5 0 49.8 22.3 49.8 49.8v796.5c0 27.5-22.3 49.8-49.8 49.8zM760.2 487.4h-224v-224h-49.8v224h-224v49.8h224v224h49.8v-224h224v-49.8z" fill="#e6e6e6"></path></svg>
                            <div class="text">新增\编辑</div></div>
                        </div>
                    </div>
                </div>

            </el-tab-pane>
            <el-tab-pane label="安装信息" name="install">  
                <div class="div-align-lr page-top-but">
                    <div>
                        <!-- <el-button type="primary" icon="el-icon-plus" @click.native="newInstall">新增安装任务</el-button> -->
                    </div>
                    <div style="width=250px">
                        <el-input placeholder="请输入内容" v-model="searchInstallVal" class="input-with-select">
                            <el-select v-model="searchInstallSelectVal" slot="prepend" placeholder="请选择">
                                <el-option label="任务编号" value="order"></el-option>
                                <el-option label="负责人" value="realname"></el-option>
                                <el-option label="团队" value="team"></el-option>
                            </el-select>
                            <el-button slot="append" icon="el-icon-search" @click="onSearchInstallBut"></el-button>
                        </el-input>
                    </div>
                </div>
                <!-- 表格 -->
                <el-table :data="installData" row-key="id" stripe style="width: 100%">
                    <el-table-column align="" prop="order" label="任务编号" sortable> </el-table-column>
                    <el-table-column align="center" prop="realname" label="负责人"> </el-table-column>
                    <el-table-column align="center" prop="create_time" label="时间" sortable> </el-table-column>
                    <el-table-column align="center" prop="type" label="类型"> </el-table-column>
                    <el-table-column align="center" prop="name" label="团队"> </el-table-column>
                    <el-table-column align="center" prop="state" label="任务状态"> </el-table-column>

                    <el-table-column align="center" label="操作" width="100">
                        <template slot-scope="scope">
                        <el-button @click="seeClick(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="维保信息" name="maintenance"> 
                <div class="div-align-lr page-top-but">
                    <div>
                        <el-button type="primary" icon="el-icon-plus" @click.native="newMaintenance">新增维修任务</el-button>
                    </div>
                    <div style="width=250px">
                        <el-input placeholder="请输入内容" v-model="searchMaintenanceVal" class="input-with-select">
                            <el-select v-model="searchMaintenanceSelectVal" slot="prepend" placeholder="请选择">
                                <el-option label="任务编号" value="order"></el-option>
                                <el-option label="负责人" value="realname"></el-option>
                                <el-option label="团队" value="team"></el-option>
                            </el-select>
                            <el-button slot="append" icon="el-icon-search" @click="onSearchMaintenanceBut"></el-button>
                        </el-input>
                    </div>
                </div>
                <!-- 表格 -->
                <el-table :data="maintenanceData" row-key="id" stripe style="width: 100%">
                    <el-table-column align="" prop="order" label="任务编号" sortable> </el-table-column>
                    <el-table-column align="center" prop="realname" label="负责人"> </el-table-column>
                    <el-table-column align="center" prop="create_time" label="时间" sortable> </el-table-column>
                    <el-table-column align="center" prop="type" label="类型"> </el-table-column>
                    <el-table-column align="center" prop="name" label="团队"> </el-table-column>
                    <el-table-column align="center" prop="state" label="任务状态"> </el-table-column>

                    <el-table-column align="center" label="操作" width="100">
                        <template slot-scope="scope">
                        <el-button @click="seeClick(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="巡查信息" name="patrol">
                <div class="div-align-lr page-top-but">
                    <div>
                        <!-- <el-button type="primary" icon="el-icon-plus" @click.native="newPatrol">新增巡查任务</el-button> -->
                    </div>
                    <div style="width=250px">
                        <el-input placeholder="请输入内容" v-model="searchPatrolVal" class="input-with-select">
                            <el-select v-model="searchPatrolSelectVal" slot="prepend" placeholder="请选择">
                                <el-option label="任务编号" value="order"></el-option>
                                <el-option label="负责人" value="realname"></el-option>
                                <el-option label="团队" value="team"></el-option>
                            </el-select>
                            <el-button slot="append" icon="el-icon-search" @click="onSearchPatrolBut"></el-button>
                        </el-input>
                    </div>
                </div>
                <!-- 表格 -->
                <el-table :data="patrolData" row-key="id" stripe style="width: 100%">
                    <el-table-column align="" prop="order" label="任务编号" sortable> </el-table-column>
                    <el-table-column align="center" prop="realname" label="负责人"> </el-table-column>
                    <el-table-column align="center" prop="create_time" label="时间" sortable> </el-table-column>
                    <el-table-column align="center" prop="type" label="类型"> </el-table-column>
                    <el-table-column align="center" prop="name" label="团队"> </el-table-column>
                    <el-table-column align="center" prop="state" label="任务状态"> </el-table-column>

                    <el-table-column align="center" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="seeClick(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    
        <!--各项详情 弹窗-->
        <el-dialog :title="dialogTiele" :visible.sync="seeVisible" :before-close="hideEditTuser" :close-on-click-modal="false" width="1000px" top="5vh">
            <table v-if="dialogDetailsData" class="top-table" width="100%" border="1" cellpadding="20" cellspacing="0" bordercolor="#ebeef5">
                <tr>
                    <td width="150" height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">单号</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.order}}</td>
                    <td width="150" bgcolor="#f5f7fa"><div align="center">任务类型</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.type}}</td>
                </tr>
                <tr>
                    <td height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">项目名称</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.project_name}}</td>
                    <td bgcolor="#f5f7fa"><div align="center">项目地址</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.project_address}}</td>
                </tr>
                <tr v-if="tabname == 'install'">
                    <td height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">新设备id</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.q_device_id}}</td>
                    <td bgcolor="#f5f7fa"><div align="center">数量</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.ep_num}}台</td>
                </tr>
                <tr>
                    <td height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">客户姓名</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.u_realname}}</td>
                    <td bgcolor="#f5f7fa"><div align="center">客户联系方式</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.u_tel}}</td>
                </tr>
                <tr>
                    <td height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">负责人</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.t_realname}}</td>
                    <td bgcolor="#f5f7fa"><div align="center">联系方式</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.t_tel}}</td>
                </tr>
                <tr>
                    <td height="50" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">任务状态</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.state}}</td>
                    <td bgcolor="#f5f7fa"><div align="center">完成时间</div></td>
                    <td>&nbsp;&nbsp;{{dialogDetailsData.finish_time}}</td>
                </tr>
                <tr>
                    <td height="100" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">备注内容</div></td>
                    <td colspan="3"><table width="100%" border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <td colspan="2">&nbsp;&nbsp;{{dialogDetailsData.remark}}</td>
                      </tr>
                      <!-- <tr>
                        <td width="50%">
                            <div>&nbsp;&nbsp;1.设备运行情况？</div>
                            <div style="color:#0099FF">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.operat_status}}</div>
                        </td>
                        <td width="50%">
                            <div>&nbsp;&nbsp;2.故障是否排除？</div>
                            <div style="color:#0099FF">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.fault_status}}</div>
                        </td>
                      </tr> -->
                    </table></td>
                </tr>
                <tr>
                    <td height="100" bordercolor="#ebeef5" bgcolor="#f5f7fa"><div align="center">巡查评分</div></td>
                    <td colspan="3"><table width="100%" border="0" cellspacing="0" cellpadding="0">
                      <!-- <tr>
                        <td width="50%">
                            <div>&nbsp;&nbsp;3.客户对此次维修评价？</div>
                            <div style="color:#0099FF">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.ue_status}}</div>
                        </td>
                        <td width="50%">
                            <div>&nbsp;&nbsp;4.对此次巡查进行评价？</div>
                            <div style="color:#0099FF">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.pe_status}}</div>
                        </td>
                      </tr> -->
                      <tr>
                        <td colspan="2" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;对此次巡查总体感受怎么样？</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.score}}</div>
                        </td>
                      </tr>
                      <tr>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;一、设备外观完整情况</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.one_score}}</div>
                        </td>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;二、设备基础厚度平整情况</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.two_score}}</div>
                        </td>
                      </tr>
                      <tr>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;三、管道接头法兰连接要求</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.three_score}}</div>
                        </td>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;四、管道进水点和出水点是否合理</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.four_score}}</div>
                        </td>
                      </tr>
                      <tr>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;五、管道要求品牌规格</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.five_score}}</div>
                        </td>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;六、电缆连接是否符合使用安全使用</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.six_score}}</div>
                        </td>
                      </tr>
                      <tr>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;七、电缆敷设是否符合安全要求</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.seven_score}}</div>
                        </td>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;八、电缆规格</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.eight_score}}</div>
                        </td>
                      </tr>
                      <tr>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;九、线管沟槽尺寸</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.nine_score}}</div>
                        </td>
                        <td width="50%" style="padding:20px 10px 10px">
                            <div>&nbsp;&nbsp;十、施工环境  安全整体美观</div>
                            <div style="color:#0099FF;padding-top:8px">&nbsp;&nbsp;&nbsp;&nbsp;{{dialogDetailsData.ten_score}}</div>
                        </td>
                      </tr>
                    </table></td>
                </tr>
            </table>
            
        </el-dialog>

        <!--新增维修任务 弹窗-->
        <el-dialog title="新增维修任务" :visible.sync="newMaintenanceVisible" :before-close="closeNewMaintenanceVisible" :close-on-click-modal="false" width="1000px" top="5vh">
            <el-form v-if="newMaintenanceSee.user" :model="newMaintenanceSee" :rules="formRules" ref="dataForm" label-width="150px">
                <el-form-item label="客户：">
                <div>{{newMaintenanceSee.user.realname}} ({{newMaintenanceSee.user.tel}})</div>
                </el-form-item>
                <el-form-item label="项目：">
                    <!-- <el-select v-model="newMaintenanceData.p_id" placeholder="请选择" @change="newMaintenanceSelect">
                        <el-option v-for="item in newMaintenanceSee.project" :key="item.id" :label="item.item_name" :value="item.id">
                        </el-option>
                    </el-select> -->
                    <div>{{newMaintenanceSee.project.item_name}}</div>
                </el-form-item>
                <el-form-item v-if="equipmentlist" label="设备id：">
                    <!-- <el-select v-model="newMaintenanceData.e_id" placeholder="请选择" @change="newEquipmentSelect">
                        <el-option v-for="item in equipmentlist" :key="item.id" :label="item.device_id" :value="item.id">
                        </el-option>
                    </el-select> -->
                    <div>{{newMaintenanceSee.equipment.device_id}}</div>
                </el-form-item>
                <el-form-item label="任务单号：">
                    <div>{{newMaintenanceData.order}}</div>
                </el-form-item>
                <!-- <el-form-item label="时间：">
                    <el-date-picker v-model="newMaintenanceData.create_time" type="date" placeholder="选择日期" value-format="timestamp"> </el-date-picker>
                </el-form-item>
                <el-form-item label="完成期限：">
                    <el-date-picker v-model="newMaintenanceData.deadline" type="date" placeholder="选择日期" value-format="timestamp"> </el-date-picker>
                </el-form-item> -->
                <!-- <el-form-item label="工期时间：" prop="startDateValus"> -->
                <el-form-item label="工期时间：">
                    <el-date-picker v-model="startDateValus" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="完成日期" value-format="timestamp"></el-date-picker>
                </el-form-item>
                <el-form-item label="任务说明：">
                    <el-input v-model="newMaintenanceData.remark" type="textarea" :rows="5" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="上传图片或视频：">
                    <el-upload ref="upload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :limit="uplimit" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" objectBind="addMaintenance" accept=".pdf, .jpg, .jpeg, .gif, .png, .bmp">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible" append-to-body>
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <div class="tUserBut">
                    <el-button type="primary" @click.native="newMaintenanceFormSubmit()" style="width:200px">保 存</el-button>
                </div>
            </el-form>
            
        </el-dialog>



    
    <!--编辑设备表单-->
    <el-dialog title="编辑设备" :visible.sync="editEquipmentVisible" :before-close="hideEditEquipment" width="1200px" top="5vh">
        <el-form :model="formEditEquipmentData" :inline="true" ref="dataEquipmentForm" label-width="150px">

            <div v-if="formEditEquipmentData" class="e-arr-itme">
                <el-form-item label="设备ID：" style="width:100%">
                    <div>{{formEditEquipmentData.device_id}}</div>
                </el-form-item>
                <el-form-item label="设备别称：" style="width:100%">
                    <el-input v-model="formEditEquipmentData.eq_name" auto-complete="off" placeholder="请输入设备别称,用于区分每台设备的位置" style="width:400px"></el-input>
                </el-form-item>
                <el-form-item label="设备序号：" style="width:100%">
                    <el-input v-model="formEditEquipmentData.GRM" auto-complete="off" placeholder="请输入设备序号" style="width:400px"></el-input>
                </el-form-item>
                <el-form-item label="设备密码：" style="width:100%">
                    <el-input v-model="formEditEquipmentData.PASS" auto-complete="off" placeholder="请输入设备密码" style="width:400px"></el-input>
                </el-form-item>
                <el-form-item label="安装时间" style="width:100%">
                    <!-- <el-input v-model="formEditEquipmentData.install_time" auto-complete="off" placeholder="请输入设备密码" style="width:400px"></el-input> -->
                    <el-date-picker v-model="formEditEquipmentData.install_time" type="datetime" placeholder="选择日期时间" value-format="timestamp" style="width:400px"> </el-date-picker>
                </el-form-item>
                <el-form-item label="设备监控图片地址：" style="width:100%">
                    <el-input v-model="formEditEquipmentData.img" auto-complete="off" placeholder="请输入设备监控图片地址" style="width:900px"></el-input>
                </el-form-item>
                <el-form-item label="设备说明书：" style="width:100%">
                    <div v-for="(item, index) in editEquipmentDataThumb" :key="index" style="display: inline-block;">
                        <el-tooltip class="item" effect="dark" :content="item.filename" placement="top">
                            <div v-if="item.ext == 'pdf'" style="width: 70px; height: 70px; margin-right: 10px;position: relative;">
                                <el-image style="width: 70px; height: 70px;margin:0" src="https://app.shengren.work/wanshuiqing/pdf.png" fit="cover"></el-image>
                                <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview" @click="openPDFVisible(item.path)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span>
                                    <span class="el-upload-list__item-delete" @click="deletePDFVisible(item.id)">
                                        <i class="el-icon-delete" style="display: block;"></i>
                                    </span>
                                </span>
                            </div>
                            <div v-else style="width: 70px; height: 70px; margin-right: 10px;position: relative;">
                                <el-image style="width: 70px; height: 70px;margin:0" :src="item.path" :preview-src-list="EsrcList" fit="cover"></el-image>
                                <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview" @click="openPDFVisible(item.path)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span>
                                    <span class="el-upload-list__item-delete" @click="deletePDFVisible(item.id)">
                                        <i class="el-icon-delete" style="display: block;"></i>
                                    </span>
                                </span>
                            </div>
                        </el-tooltip>
                    </div>
                    <el-upload ref="upload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :limit="uplimit" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" objectBind="editEquipment" accept=".pdf, .jpg, .jpeg, .gif, .png, .bmp">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible" append-to-body>
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
            </div>


            <div class="dialog-footer">
                <el-button type="primary" @click.native="formEquipmentSubmit()" style="width:200px">提 交</el-button>
            </div>
        </el-form>
    </el-dialog>

    

    <!--新增\编辑-->
    <el-dialog title="新增\编辑 现场图片" :visible.sync="uploadPhotoVisible" :before-close="hideUploadPhoto" width="1200px" top="5vh">
        <div v-for="(item, index) in eimgXianchang" :key="index" style="display: inline-block;">
            <div style="width: 148px; height: 200px; margin-right: 10px;position: relative;">
                <el-image style="width: 148px; height: 148px;margin:0" :src="item.path" :preview-src-list="srcList" fit="cover"></el-image>
                <div class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="openPDFVisible(item.path)">
                        <i class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list__item-delete" @click="deleteUploadPhoto(item.id)">
                        <i class="el-icon-delete" style="display: block;"></i>
                    </span>
                </div>
                <div style="margin-top:30px;width:148px"><el-input v-model="item.remark" show-word-limit placeholder="备注"> </el-input></div>
            </div>
            
        </div>
        <!--<el-upload ref="upload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" objectBind="scenePictures" accept=".jpg, .jpeg, .gif, .png, .bmp">
             <i class="el-icon-plus"></i>
            <div style="width:148px;margin-right:8px;"><el-input v-model="allWaterIndicatorsTimeData.air" show-word-limit placeholder="备注"> </el-input></div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog> -->

        <!-- <div style="display: flex;margin-top:10px;">
            <div style="width:148px;margin-right:8px;"><el-input v-model="allWaterIndicatorsTimeData.air" show-word-limit placeholder="备注"> </el-input></div>
            <div style="width:148px;margin-right:8px;"><el-input v-model="allWaterIndicatorsTimeData.air" show-word-limit placeholder="备注"> </el-input></div>
        </div> -->
        <el-upload ref="pictureUpload" :action="uploadAPI" :data="uploadData" :headers="uploadHeaders" list-type="picture-card" :multiple="false" :on-success="handleSuccess" :on-error="handleError" :before-upload="beforeUpload" objectBind="scenePictures" accept=".jpg, .jpeg, .gif, .png, .bmp" class="YYY">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
                    <span class="el-upload-list__item-delete" @click="handleRemove(file)"><i class="el-icon-delete"></i></span>
                </span>
                <div style="width:148px;padding-top:150px;"><el-input v-model="pictureUploadVal[file.name]" show-word-limit placeholder="备注"> </el-input></div>
            </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" append-to-body><img width="100%" :src="dialogImageUrl" alt=""></el-dialog>

        <div class="dialog-footer" style="padding-top:50px;">
            <el-button type="primary" @click.native="formUploadPhotoSubmit()" style="width:200px">提 交</el-button>
        </div>
    </el-dialog>

    <!-- 水质记录列表 -->
    <el-dialog title="水质记录" :visible.sync="allWaterIndicatorsVisible" :before-close="closeAllWaterIndicatorsVisible" width="90%" top="5vh">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:30px;">
            <div>
                <el-date-picker style="width:260px" v-model="allWaterIndicatorsTime" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time = "['00:00:00','23:59:59']" value-format="timestamp"></el-date-picker>
                <el-button type="primary" plain icon="el-icon-search" @click.native="allWaterIndicatorsTimeSearch()">搜索</el-button>
            </div>
            <el-button type="primary" icon="el-icon-plus" @click.native="allWaterIndicatorsTimeAdd(null, null)">新增水质记录</el-button>
        </div>
        <el-table :data="allWaterIndicatorsData" row-key="id" stripe style="width: 100%">
            <el-table-column align="center" prop="detect_time" label="检测日期" sortable> </el-table-column>
            <el-table-column align="center" prop="air" label="气温(℃)"> </el-table-column>
            <el-table-column align="center" prop="ntu" label="浊度(NTU)"> </el-table-column>
            <el-table-column align="center" prop="cod" label="COD(mg/L)"> </el-table-column> 
            <el-table-column align="center" prop="bod" label="BOD(mg/L)"> </el-table-column> 
            <el-table-column align="center" prop="anyan" label="氨氮(mg/L)"> </el-table-column> 
            <el-table-column align="center" prop="zongyan" label="总氮(mg/L)"> </el-table-column> 
            <el-table-column align="center" prop="zonglin" label="总磷(mg/L)"> </el-table-column> 
            <el-table-column align="center" prop="oxygen" label="溶解氧(mg/L)"> </el-table-column> 
            <el-table-column align="center" prop="ph" label="pH"> </el-table-column> 
            <el-table-column align="center" prop="oxidation" label="氧化还原电位(mV)"> </el-table-column> 
            <el-table-column align="center" prop="transparent" label="透明度(cm)"> </el-table-column> 
            <el-table-column align="center" prop="remark" label="备注"> </el-table-column> 

            <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="allWaterIndicatorsTimeAdd(scope.$index, scope.row),drawer = true" slot="reference" type="text" size="small" icon="el-icon-edit">编辑</el-button>
					<el-button @click.native="allWaterIndicatorsTimeDel(scope.$index, scope.row)" type="text" size="small" icon="el-icon-delete"> 删除 </el-button>
                </template>
            </el-table-column>
        </el-table>
            
        <div class="pageWrap">
            <el-pagination background layout="prev, pager, next" :hide-on-single-page="true" :current-page.sync="allWaterIndicatorsPage.current_page" :page-size="allWaterIndicatorsPage.per_page" :total="allWaterIndicatorsPage.total" @current-change="handleallWaterCurrentChange"></el-pagination>
        </div>
    </el-dialog>
    
    <!--新增水质记录-->
    <el-dialog title="新增水质记录" :visible.sync="addWaterIndicatorsTimeVisible" :before-close="allWaterIndicatorsTimeAddClose" width="1200px" top="5vh">
        <el-form :model="allWaterIndicatorsTimeData" :inline="true" ref="allWaterIndicatorsTimeForm" label-width="150px">
            <el-form-item label="检测日期：">
                <el-date-picker v-model="allWaterIndicatorsTimeData.detect_time" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
            <el-form-item label="气温(℃)：">
                <el-input v-model="allWaterIndicatorsTimeData.air" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="浊度(NTU)：">
                <el-input v-model="allWaterIndicatorsTimeData.ntu" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="COD(mg/L)：">
                <el-input v-model="allWaterIndicatorsTimeData.cod" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="BOD(mg/L)：">
                <el-input v-model="allWaterIndicatorsTimeData.bod" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="氨氮(mg/L)：">
                <el-input v-model="allWaterIndicatorsTimeData.anyan" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="总氮(mg/L)：">
                <el-input v-model="allWaterIndicatorsTimeData.zongyan" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="总磷(mg/L)：">
                <el-input v-model="allWaterIndicatorsTimeData.zonglin" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="溶解氧(mg/L)：">
                <el-input v-model="allWaterIndicatorsTimeData.oxygen" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="pH：">
                <el-input v-model="allWaterIndicatorsTimeData.ph" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="氧化还原电位(mV)：">
                <el-input v-model="allWaterIndicatorsTimeData.oxidation" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="透明度(cm)：">
                <el-input v-model="allWaterIndicatorsTimeData.transparent" show-word-limit placeholder="请输入数值"> </el-input>
            </el-form-item>
            <el-form-item label="备注：" style="width:100%">
                <el-input v-model="allWaterIndicatorsTimeData.remark" type="textarea" :rows="6" maxlength="100" show-word-limit placeholder=""> </el-input>
            </el-form-item>
        </el-form>

        <div class="dialog-footer">
            <el-button type="primary" @click.native="allWaterIndicatorsTimeSubmit()" style="width:200px">保 存</el-button>
        </div>
    </el-dialog>


    </div>
</template>


<script>
import {
    apiEquipmentdata,
    apiEquipmentSwitch,
    apiAllTasklistData,
    apiAllTaskdetailsData,
    apiAddWTask,
    apiAddWTaskPost,
    apiEquipmentlist,
    apiOrder,
    apiEquipmentEdit,
    apiEquipmentEditSubmit,
    apiEimgXianchang,
    apiEditWaterIndicators,
    apiEditWaterIndicatorsTime,
    waterIndicatorsSave,
    waterIndicatorsDelete
} from "../../api/views/customer";
import { constantRouterMap } from '../../router';
import * as echarts from 'echarts'
import { getCookie } from "../../utils/rules";
const allWaterIndicatorsTimeFormJson = {
    e_id: '',
    id:'',
    detect_time:'',
    air:'',
    ntu: '',
    cod:'',
    bod: '',
    anyan: '',
    zongyan: '',
    zonglin: '',
    oxygen: '',
    ph: '',
    oxidation: '',
    transparent: '',
    remark: ''
}
export default {
    data() {
        return {
            query:{
                id: "",
            },
            activeName: 'equipment',
            tableData:[],
            projecListPane: [],
            srcList: [],
            EsrcList: [],
            // equipmentData:[],
            installData:[],
            maintenanceData:[],
            patrolData:[],
            dialogDetailsData: [],
            tabname: '',
            searchInstallVal:'',
            searchInstallSelectVal:'',
            searchMaintenanceVal:'',
            searchMaintenanceSelectVal:'',
            searchPatrolVal:'',
            searchPatrolSelectVal:'',
            seeVisible: false,
            dialogTiele: '',
            newMaintenanceVisible: false,
            newMaintenanceSee:[],
            newMaintenanceData:{
                "uid": "",//客户数据表id    
                "p_id":"",//项目数据表id
                "e_id":"",//需要维修设备id
                "order":"",//任务单号
                "create_time":"",//时间（时间戳）
                "deadline":"",//完成期限
                "remark":"",//任务数码
                'thumb':""  //上传文件数据表id
            },
            formRules:{startDateValus: [{required: true, message: '请设置工期时间', trigger: 'blur'}],},
            newMaintenanceOptions:[],
            newMaintenanceSelectVal: '',
            startDateValus: '',
            endDateValus: '',
            equipmentlist:[],
            beNum: '',

            
            uploadAPImap: {
                "editEquipment": process.env.VUE_APP_API_BASE + '/admin/index/eadd_upload',
                'addMaintenance': process.env.VUE_APP_API_BASE + '/admin/index/w_task_upload',
                "scenePictures": process.env.VUE_APP_API_BASE + '/admin/index/eimg_upload'
            },
            uploadAPI: '',
            uploadHeaders: {},

            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            uploadData:{},
            uplimit: 9,
            fileSuffix:'',
            uploadSwitch: false,
            uploadReply: [],
            pictureUploadVal: {}, 

            chartColumn: null,
            xAxisData: [],
            waterCODdata: [],
            legendData: [],
            waterSeries: [],
            waterData: {
                // detect_time: [],
                air: [],
                ntu: [],
                cod: [],
                bod: [],
                anyan: [],
                zongyan: [],
                zonglin: [],
                oxygen: [],
                ph: [],
                oxidation: [],
                transparent: []
            },
            waterTransparencyData: [],
            editEquipmentVisible: false,
            formEditEquipmentData: {},
            editEquipmentDataThumb: [],
            uploadPhotoVisible: false,
            eimgXianchang: [],

            allWaterIndicatorsVisible: false,
            allWaterIndicatorsData: [],
            allWaterIndicatorsPage: {},
            allWaterIndicatorsTime: '',
            addWaterIndicatorsTimeVisible: false,
            formWaterIndicatorsName: 'add',
            allWaterIndicatorsTimeData: allWaterIndicatorsTimeFormJson
        };
    },
    created:function() {
        let newGetList = (id) => {
            return new Promise((resolve, reject) => {
                this.getList({id:id})
                resolve()
            })
        }
        console.log(this.$route.query)
        if(this.$route.query.id){
            this.βgetApp.globalData.equipmentID = this.$route.query.id
            this.query.id = this.$route.query.id
            newGetList(this.$route.query.id).then(()=>{})
        }else if(this.$route.query.tabname && this.$route.query.eid){
            this.βgetApp.globalData.equipmentID = this.$route.query.eid
            this.βgetApp.globalData.equipmentTabname = this.$route.query.tabname
            this.query.id = this.$route.query.id
            newGetList(this.$route.query.eid).then(_ => {
                setTimeout(() => {
                    this.activeName = this.$route.query.tabname
                    this.tabname = this.$route.query.tabname
                    this.getAllTasklistData(this.$route.query.tabname,{id:this.$route.query.eid})
                    this.getAllTaskdetailsData(this.$route.query.tabname,{id:this.$route.query.tid,notice_id:this.$route.query.notice_id?this.$route.query.notice_id:''})
                    this.seeVisible = true
                }, 1500)
            })
        }else{
            this.getList({id:this.βgetApp.globalData.equipmentID})
            this.query.id = this.βgetApp.globalData.equipmentID
        }
    },
    methods: {
        // 上传前钩子
        beforeUpload(file){
            const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
            const whiteList = ['pdf', 'jpg', 'jpeg', 'gif', 'png', 'bmp'];
            if (whiteList.indexOf(fileSuffix) === -1) {
                this.$message({
                    message: "上传文件格式错误！",
                    type: "error"
                })
                return false;
            }
            // const isLt2M = file.size / 1024 / 1024 < 4;
            // if (!isLt2M) {
            //     this.$message({
            //         message: "上传文件大小不能超过 4MB！",
            //         type: "error"
            //     })
            //     return false;
            // }
            this.uploadData.upload = file
            this.fileSuffix = file.name.substring(file.name.lastIndexOf('.')+1)
            this.fileFormat = file.type.toString().split('/')
        },
        // 上传成功的回调钩子
        handleSuccess(response, file, fileList, typt){
            console.log(this.βimgBaseUrl+response.path)
            response.name = file.name
            this.uploadReply.push(response)
            if(this.fileFormat[0] == 'image') {
                file.url = file.url
            }else if(this.fileFormat[0] == 'video'){
                file.url = 'http://app.shengren.work/wanshuiqing/video.png'
            }else if(this.fileSuffix == 'pdf'){
                file.url = 'http://app.shengren.work/wanshuiqing/pdf.png'
            }else{
                file.url = 'http://app.shengren.work/wanshuiqing/file.png'
            }
            this.pictureUploadVal = {[file.name]:''}
            console.log("pictureUploadVal",this.pictureUploadVal)
        },
        // 上传失败的回调钩子
        handleError(response, file, fileList) {
            console.log('error-----------')
            // console.log(response)
            console.log(file)
            console.log('response',this.$refs.upload)
            // this.isImporting = false
            // this.$refs.upload.clearFiles()
        },
        // 移除文件钩子
        handleRemove(file, fileList) {
            const newArr = this.uploadReply.filter((item) => {
                return !file.name.includes(item.name)
            })

            // this.$refs.pictureUpload.uploadFiles = []
            console.log(file.name)
            if(this.$refs.pictureUpload){
                this.$refs.pictureUpload.uploadFiles = this.$refs.pictureUpload.uploadFiles.filter((item) => {
                    return !file.name.includes(item.name)
                })
                console.log(this.$refs.pictureUpload.uploadFiles)
            }

            
            this.uploadReply = newArr
            console.log(newArr)
            console.log(this.uploadReply)
            console.log(this.dialogImageUrl)
        },
        // 点击文件列表中已上传的文件时的钩子
        handlePictureCardPreview(file) {
            console.log(this.fileFormat[0])
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
            console.log(file.url)
            console.log(file.type)
        },
        getList(query) {
            this.uploadHeaders = {
                "X-Adminid": getCookie('ADMIN-ID'),
                "X-Token": getCookie('ADMIN-TOKEN')
            }
            apiEquipmentdata(query).then(res => {
                res.equipment.install_time = this.isNumbera(res.equipment.install_time)&&(res.equipment.install_time + '').length===10?this.formatDate(res.equipment.install_time*1000):'未完成安装任务'
                res.equipment.egis_time = this.isNumbera(res.equipment.egis_time)&&(res.equipment.egis_time + '').length===10?this.formatDate(res.equipment.egis_time*1000):'暂无维保记录'
                res.equipment.switch = res.equipment.switch == '1' || res.equipment.switch == 1 ? true : false
                res.water_indicators.detect_time = this.isNumbera(res.water_indicators.detect_time)&&(res.water_indicators.detect_time + '').length===10?this.formatDate(res.water_indicators.detect_time*1000):'--'
                for(let i of res.equipment.thumb) {
                    i.path = this.βimgBaseUrl+i.path
                    if(i.ext !== 'pdf') this.EsrcList.push(i.path)
                }
                for (let i of res.equipmentdata) {
                    this.xAxisData.push(i.detect_time)
                    this.waterData.air.push(i.air)
                    this.waterData.ntu.push(i.ntu)
                    this.waterData.cod.push(i.cod)
                    this.waterData.bod.push(i.bod)
                    this.waterData.anyan.push(i.anyan)
                    this.waterData.zongyan.push(i.zongyan)
                    this.waterData.zonglin.push(i.zonglin)
                    this.waterData.oxygen.push(i.oxygen)
                    this.waterData.ph.push(i.ph)
                    this.waterData.oxidation.push(i.oxidation)
                    this.waterData.transparent.push(i.transparent)
                }
                let colorMap = {
                        air: '#8B7AF0',
                        ntu:'#6692FF',
                        cod: '#70D5FF',
                        bod: '#45C897',
                        anyan: '#62D929',
                        zongyan: '#FFDC62',
                        zonglin: '#FFBA2E',
                        oxygen: '#FF8A1F',
                        ph: '#FF8199',
                        oxidation: '#E9594F',
                        transparent: '#2B2995',
                    }
                for(let i in  res.equipmentdata[0]){
                    if(i !== "detect_time"){
                        this.legendData.push(this.βwaterIndicatorsMap[i])
                        let waterSeriesObj = {
                            name: this.βwaterIndicatorsMap[i], 
                            smooth: true,
                            type: 'line',
                            itemStyle: {
                                normal: {
                                    color: colorMap[i],
                                    lineStyle: {
                                        color: colorMap[i],
                                        width: 2
                                    }
                                }
                            },
                            data: this.waterData[i],
                            animationDuration: 2800,
                            animationEasing: 'cubicInOut'
                        }
                        this.waterSeries.push(waterSeriesObj)
                    }
                }
                for(let i of res.eq_images) i.path = this.βimgBaseUrl+i.path
                this.tableData = res
                this.srcList = []
                for(let i of res.eq_images) this.srcList.push(i.path)
                // console.log(this.srcList)
            }).catch(err => {
                console.log('获取列表-失败',err)
            })
        },
        doPriveImg(){
            this.$refs.myImg.showViewer = true
        },
        equipmentSwitch(e){
            console.log(e)
            const that = this
            let onSwitch = !that.tableData.equipment.switch?0:1,
            switchtext = that.tableData.equipment.switch?'设备开机':'关闭设备'
            // console.log(onSwitch)
            that.$confirm(switchtext, '提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then( async () => {
                await onEquipmentSwitch()
            }).catch(_ => {
                that.$message({
                    type: 'info',
                    message: '已取取消'+switchtext+'操作'
                })
                that.tableData.equipment.switch = !that.tableData.equipment.switch
            })
            function onEquipmentSwitch(){
                apiEquipmentSwitch({id:e,switch:onSwitch}).then(res => {
                    // console.log(res)
                    if(res.code!=1){
                        that.$message({
                            message: res.message,
                            type: "success"
                        });
                    }else{
                        that.$message({
                            message: res.message,
                            type: "error"
                        })
                        that.tableData.equipment.switch = !that.tableData.equipment.switch
                    }
                })
            }
        },
        handleClick(tab, event) {
            let query = {id:this.tableData.equipment.id}
            this.tabname = tab.name
            this.getAllTasklistData(tab.name,query)
        },
        seeClick(row){
            // console.log(row)
            let query = {id:row.id},
                type = this.tabname
            this.getAllTaskdetailsData(type,query)
            this.seeVisible = true
        },
        hideEditTuser(){
            this.seeVisible = false
        },
        onSearchInstallBut(){
            let type = this.tabname,query = {id:this.tableData.equipment.id}
            query[this.searchInstallSelectVal] = this.searchInstallVal
            if(this.searchInstallSelectVal && this.searchInstallVal){
                this.getAllTasklistData(type,query)
            }else if(!this.searchInstallSelectVal){
                this.$message({
                    message: '搜索类型不能为空',
                    type: "error"
                })
            }else if(!this.searchInstallVal){
                this.$message({
                    message: '搜索内容不能为空',
                    type: "error"
                })
            }
        },
        onSearchMaintenanceBut(){
            let type = this.tabname,query = {id:this.tableData.equipment.id}
            query[this.searchMaintenanceSelectVal] = this.searchMaintenanceVal
            if(this.searchMaintenanceSelectVal && this.searchMaintenanceVal){
                this.getAllTasklistData(type,query)
            }else if(!this.searchMaintenanceSelectVal){
                this.$message({
                    message: '搜索类型不能为空',
                    type: "error"
                })
            }else if(!this.searchMaintenanceVal){
                this.$message({
                    message: '搜索内容不能为空',
                    type: "error"
                })
            }
        },
        onSearchPatrolBut(){
            let type = this.tabname,query = {id:this.tableData.equipment.id}
            query[this.searchPatrolSelectVal] = this.searchPatrolVal
            if(this.searchPatrolSelectVal && this.searchPatrolVal){
                this.getAllTasklistData(type,query)
            }else if(!this.searchPatrolSelectVal){
                this.$message({
                    message: '搜索类型不能为空',
                    type: "error"
                })
            }else if(!this.searchPatrolVal){
                this.$message({
                    message: '搜索内容不能为空',
                    type: "error"
                })
            }
        },
        newMaintenance(){
            this.uploadAPI = this.uploadAPImap['addMaintenance']
            let query = {id:this.βgetApp.globalData.equipmentID}
            this.newMaintenanceVisible = true
            this.newMaintenanceData = {
                "uid": "",//客户数据表id    
                "p_id":"",//项目数据表id
                "e_id":"",//需要维修设备id
                "order":"",//任务单号
                "create_time":"",//时间（时间戳）
                "deadline":"",//完成期限
                "remark":"",//任务数码
                'thumb':""  //上传文件数据表id
            },
            apiAddWTask(query).then(res => {
                // console.log('apiAddWTask',res)
                this.newMaintenanceSee = res
                this.newMaintenanceData.uid = res.user.id
                this.newMaintenanceData.e_id = res.equipment.id
                this.newMaintenanceData.p_id = res.project.id
                this.isApiOrder()
            }).catch(err => {
                console.log('获取列表-失败',err)
            })
        },
        closeNewMaintenanceVisible(){
            this.newMaintenanceVisible = false
        },
        newMaintenanceSelect(){
            const that = this
            // console.log(this.newMaintenanceData.p_id)
            let query = {id:this.newMaintenanceData.p_id}
            that.equipmentlist = []
            that.newMaintenanceData.e_id = ''
            apiEquipmentlist(query).then(res => {
                for(let i of res){
                    // console.log(i)
                    // that.newMaintenanceSee.equipmentlist.push(i)
                    that.equipmentlist.push(i)
                }
                // console.log('res',res)
                // console.log(that.newMaintenanceSee)
                // that.newMaintenanceSee = that.newMaintenanceSee
            }).catch(err => {
                console.log('获取列表-失败',err)
            })
        },
        newEquipmentSelect(){
            console.log('newMaintenanceData',this.newMaintenanceData)
        },
        getAllTasklistData(type,query){
            if(type == 'install' || type == 'maintenance' || type == 'patrol'){
                apiAllTasklistData(type,query).then(res => {
                    console.log(res)
                    if(type == 'install' && this.installData.length == 0){
                        for(let i of res.data){
                            i.type = '设备安装'
                            // i.type = i.type == 1 ? '设备新装':i.type == 2 ? '维保任务':i.type == 3 ? '巡查任务':i.type
                            i.state = i.state == 1 ? '新任务':i.state == 2 ? '进行中':i.state == 3 ? '已完成':i.state
                            i.create_time = this.formatDate(i.create_time*1000)
                        }
                        this.installData = res.data
                    }
                    // if(type == 'maintenance' && this.installData.length == 0){
                    if(type == 'maintenance'){
                        for(let i of res.data){
                            i.type = i.type == 1 ? '设备维修':i.type == 2 ? '更换设备':i.type
                            i.state = i.state == 1 ? '新任务':i.state == 2 ? '进行中':i.state == 3 ? '更换设备':i.state == 4 ? '已完成':i.state
                            i.create_time = this.formatDate(i.create_time*1000)
                        }
                        this.maintenanceData = res.data
                    }
                    if(type == 'patrol' && this.installData.length == 0){
                        for(let i of res.data){
                            i.type = i.type == 1 ? '巡查安装任务':i.type == 2 ? '巡查维护任务':i.type
                            // i.state = i.state == 1 ? '新任务':i.state == 2 ? '进行中':i.state == 3 ? '已完成':i.state
                            i.state = i.state == 1 ? '新任务':i.state == 2 ? '已完成':i.state
                            i.create_time = this.formatDate(i.create_time*1000)
                        }
                        this.patrolData = res.data
                    }
                }).catch(err => {
                    console.log('获取列表-失败',err)
                })
            }
        },
        getAllTaskdetailsData(type,query){
            apiAllTaskdetailsData(type,query).then(res => {
                if(type == 'install'){
                    this.dialogTiele = '新设备详情'
                    res.type = res.type == 1 ? "安装任务": res.type
                    res.state = res.state == 1 ? "新任务" : res.state == 2 ? "进行中" : res.state == 3 ? "已完成" : res.state
                }
                if(type == 'maintenance'){
                    this.dialogTiele = '设备' + res.device_id
                    res.type = res.type == 1 ? "设备维修": res.type == 2 ? "更换设备": res.type
                    res.state = res.state == 1 ? "新任务" : res.state == 2 ? "进行中" : res.state == 3 ? "更换设备" : res.state == 4 ? "已完成" : res.state
                }
                if(type == 'patrol'){
                    this.dialogTiele = '设备' + res.device_id
                    res.type = res.type == 1 ? "巡查安装任务":res.type == 2 ? "巡查维护任务": res.type
                    res.state = res.state == 1 ? "新任务" : res.state == 2 ? "已完成" : res.state
                }
                res.finish_time = res.finish_time == null ? "--" : this.formatDate(res.finish_time*1000)
                res.operat_status = res.operat_status == null ? "--" : res.operat_status == 1 ? "正常" : res.operat_status == 2 ? "不正常" : res.operat_status
                res.fault_status = res.fault_status == null ? "--" : res.fault_status == 1 ? "已排除" : res.fault_status == 2 ? "未排除" : res.fault_status
                res.ue_status = res.ue_status == null ? "--" : res.ue_status == 1 ? "优秀" : res.ue_status == 2 ? "良好": res.ue_status == 3 ? "不满意" : res.ue_status
                res.pe_status = res.pe_status == null ? "--" : res.pe_status == 1 ? "优秀" : res.pe_status == 2 ? "良好": res.pe_status == 3 ? "差" : res.pe_status

               
                let scoreMpa = {
                    0:'--',
                    1:'合格',
                    2:'基本合格',
                    3:'差'
                }
                res.score = res.score == null || res.score == 0 ? "--" : res.score == 1 ? "满意" : res.score == 2 ? "一般": res.score == 3 ? "良好" : res.score
                res.one_score = scoreMpa[res.one_score]
                res.two_score = scoreMpa[res.two_score]
                res.three_score = scoreMpa[res.three_score]
                res.four_score = scoreMpa[res.four_score]
                res.five_score = scoreMpa[res.five_score]
                res.six_score = scoreMpa[res.six_score]
                res.seven_score = scoreMpa[res.seven_score]
                res.eight_score = scoreMpa[res.eight_score]
                res.nine_score = scoreMpa[res.nine_score]
                res.ten_score = scoreMpa[res.ten_score]
                

                this.dialogDetailsData = res
            }).catch(err => {
                console.log('获取列表-失败',err)
            })
        },
        isApiOrder(){
            let num = 'RW' + Math.floor(Math.random() * (1000000 - 1)) + 1
            // this.funOrder(num).then(res => {
            //     console.log(res)
            //     if(res == 0){
            //         this.newMaintenanceData.order = num
            //     }else{
            //         let setIntervalError = setInterval(() => {
            //             this.funOrder(num)
            //         }, 1000)
            //         setTimeout(() => {
            //             clearInterval(setIntervalError)
            //         }, 5000)
            //     }
            // })
            this.funOrder(num).then(res => {
                let setIntervalError = setInterval(() => {
                    this.funOrder(num)
                }, 1000)
                if(res == 0){
                    clearInterval(setIntervalError)
                }else{
                    setIntervalError
                    setTimeout(() => {
                        clearInterval(setIntervalError)
                    }, 5000)
                }
            })
            // console.log(this.newMaintenanceData.order)
        },
        funOrder(num) {
            const that = this
            return new Promise(function (resolve, reject) {
                apiOrder({order:num}).then(res => {
                    if(res == 0) that.newMaintenanceData.order = num
                    resolve(res)
                }).catch(err => {
                    console.log('获取列表-失败',err)
                    reject(err)
                })

            })
        },
        newMaintenanceFormSubmit(){
            const that = this
            that.$refs["dataForm"].validate(valid => {
                if (valid) {
                    let newData = that.newMaintenanceData, reply = that.uploadReply
                    newData.create_time = that.startDateValus[0]/1000
                    newData.deadline = that.startDateValus[1]/1000
                    newData.thumb = ''
                    for(let i of reply) newData.thumb += i.id + ','
                    newData.thumb = newData.thumb.substring(0, newData.thumb.lastIndexOf(','))
                    let data = Object.assign({}, newData)
                    apiAddWTaskPost(data).then(response => {
                        // console.log(response)
                        if (response.code == 0) {
                            that.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            // 更改值
                            that.newMaintenanceVisible = !that.newMaintenanceVisible;
                            // 清空表单
                            that.$refs["dataForm"].resetFields()
                            this.newMaintenanceSee = []
                            that.newMaintenanceData = {}
                            that.uploadReply = []
                            that.startDateValus = []
                            // 刷新列表
                            this.getAllTasklistData(this.tabname,{id:this.tableData.equipment.id})
                        }else{
                            that.$message({
                                message: response.message,
                                type: "error"
                            })
                        }
                    })
                }
            })
        },
        formatDate(date) {
            var date = new Date(date);
            var YY = date.getFullYear() + '-';
            var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
            var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
            var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            return YY + MM + DD +" "+hh + mm + ss;
        },
        isNumbera(val) {
            var re = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/ 
            if (!re.test(val)) {
                return false;
            }else{
                return true
            }
        },
        
        drawLine(){
            // console.log(echarts)
            this.chartColumn = echarts.init(document.getElementById('macarons'));
            this.chartColumn.setOption({
                xAxis: {
                    data: this.xAxisData,
                    boundaryGap: false,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {  
                        interval:0,  
                        rotate:40  
                    }  
                },
                grid: {
                    left: 10,
                    right: 10,
                    bottom: 20,
                    top: 30,
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    },
                    padding: [5, 10]
                },
                yAxis: {
                    show: false,
                    axisTick: {
                        show: false
                    }
                },
                legend: {
                    data: this.legendData
                },
                series: this.waterSeries
                // [
                //     {
                //         name: '水体COD', 
                //         smooth: true,
                //         type: 'line',
                //         itemStyle: {
                //             normal: {
                //                 color: '#42b983',
                //                 lineStyle: {
                //                     color: '#42b983',
                //                     width: 2
                //                 }
                //             }
                //         },
                //         data: this.waterData.cod,
                //         animationDuration: 2800,
                //         animationEasing: 'cubicInOut'
                //     },
                //     {
                //         name: '水体透明度',
                //         smooth: true,
                //         type: 'line',
                //         itemStyle: {
                //             normal: {
                //                 color: '#3888fa',
                //                 lineStyle: {
                //                     color: '#3888fa',
                //                     width: 2
                //                 },
                //                 areaStyle: {
                //                     color: '#f3f8ff'
                //                 }
                //             }
                //         },
                //         data: this.waterData.transparent,
                //         animationDuration: 2800,
                //         // animationEasing: 'quadraticOut'
                //         animationEasing: 'cubicInOut'
                //     }
                // ]
            });
        },
        editEquipment(){
            const that = this
            this.uploadAPI = this.uploadAPImap['editEquipment']
            
            apiEquipmentEdit({id:this.βgetApp.globalData.equipmentID}).then(response => {
                console.log('response',response)
                    that.editEquipmentVisible = !that.editEquipmentVisible
                    let editEquipmentDataThumb = response.thumb
                    console.log(response.install_time === null)
                    response.install_time = response.install_time === null ? '': response.install_time *1000
                    that.formEditEquipmentData = response
                    for(let i of editEquipmentDataThumb) {
                        i.path = this.βimgBaseUrl+i.path
                    }
                    that.editEquipmentDataThumb = editEquipmentDataThumb
                    console.log(this.tabname)
            })

        },
        hideEditEquipment(){
            this.editEquipmentVisible = false
        },
        formEquipmentSubmit(){
            // console.log('编辑设备提交')
            let formEditEquipmentData = { ...this.formEditEquipmentData }
            formEditEquipmentData.thumb = []
            for(let i of this.formEditEquipmentData.thumb) formEditEquipmentData.thumb.push(i.id)
            if(this.uploadReply.length > 0) {
                for(let i of this.uploadReply) formEditEquipmentData.thumb.push(i.id)
            }
            formEditEquipmentData.thumb = formEditEquipmentData.thumb.toString()
            let data = {
                id: formEditEquipmentData.id,
                eq_name: formEditEquipmentData.eq_name,
                grm: formEditEquipmentData.GRM,
                pass: formEditEquipmentData.PASS,
                img: formEditEquipmentData.img,
                thumb: formEditEquipmentData.thumb,
                install_time: formEditEquipmentData.install_time
            }
            // console.log(formEditEquipmentData)
            // console.log(this.uploadReply)
            apiEquipmentEditSubmit(data).then(res=>{
                // console.log(res)
                if (res.code === 0) {
                    this.editEquipmentVisible = false
                    this.uploadReply = []
                    if (this.$refs["dataForm"]) this.$refs["dataForm"].resetFields()
                    this.$refs.upload.clearFiles()
                    this.$message({
                        message: res.message,
                        type: "success"
                    })
                    console.info(this.βgetApp.globalData.equipmentID)
                    this.getList({id:this.βgetApp.globalData.equipmentID})
                } else {
                    this.$message({
                        message: res.message,
                        type: "error"
                    })
                }
            })
        },
        openPDFVisible(row){
            window.open(row,"_blank")
        },
        deletePDFVisible(e){
            const editEquipmentDataThumb = this.editEquipmentDataThumb,
                formEditEquipmentData = this.formEditEquipmentData.thumb,
                index = editEquipmentDataThumb.findIndex((item) => item.id === e)
            editEquipmentDataThumb.splice(index, 1)
            formEditEquipmentData.splice(index, 1)
            this.editEquipmentDataThumb = editEquipmentDataThumb
            this.formEditEquipmentData.thumb = formEditEquipmentData
        },
        hover(){
            this.uploadAPIType = 'scenePictures'
            this.uploadAPI = this.uploadAPImap['scenePictures']
        },
        openUploadPhoto(){
            this.uploadPhotoVisible = true
            this.uploadAPIType = 'scenePictures'
            this.uploadAPI = this.uploadAPImap['scenePictures']
            this.uploadData.id = this.βgetApp.globalData.equipmentID
            this.eimgXianchang = []
            let eimgXianchang = JSON.parse(JSON.stringify(this.tableData.eq_images))
            // for(let i of eimgXianchang) i.path = this.βimgBaseUrl+i.path
            for(let i of eimgXianchang) i.path = i.path
            this.eimgXianchang = eimgXianchang
        },
        hideUploadPhoto(){
            this.uploadPhotoVisible = false
            this.eimgXianchang = []
            // if(this.$refs.upload) this.$refs.upload.clearFiles()
            if(this.$refs.pictureUpload) this.$refs.pictureUpload.clearFiles()
            
        },
        deleteUploadPhoto(e){
            const eimgXianchang = this.eimgXianchang,
                index = eimgXianchang.findIndex((item) => item.id === e)
            eimgXianchang.splice(index, 1)
            this.eimgXianchang.thumb = eimgXianchang
        },
        formUploadPhotoSubmit(){
            let thumb = {}, thumb1 = {}, thumb2 = {}
            if(this.eimgXianchang.length > 0) {
                let Obj = {}
                for(let i of this.eimgXianchang) {
                    Obj[i.id] = i.remark
                }
                thumb1 = Obj
            }
            if(this.uploadReply.length > 0) {
                let Obj = {}
                for(let i of this.uploadReply) {
                    Obj[i.id]=this.pictureUploadVal[i.name]
                    // console.log(i)
                }
                thumb2 = Obj
            }
            thumb = Object.assign(thumb1,thumb2)
            // console.log(thumb1)
            // console.log(thumb2)
            // console.log(thumb)
            let data = {
                id: this.βgetApp.globalData.equipmentID,
                // thumb: thumb.toString()
                thumb: thumb
            }
            apiEimgXianchang(data).then(res => {
                if (res.code === 0) {
                    this.hideUploadPhoto()
                    this.$refs.pictureUpload.clearFiles()
                    this.$message({
                        message: res.message,
                        type: "success"
                    })
                    console.info(this.βgetApp.globalData.equipmentID)
                    this.getList({id:this.βgetApp.globalData.equipmentID})
                } else {
                    this.$message({
                        message: res.message,
                        type: "error"
                    })
                }
            }).catch(err => {
                console.log('获取列表-失败',err)
            })
        },
        editWaterIndicators(){
            this.allWaterIndicatorsVisible = true
            this.getEditWaterIndicators(null,null)
        },
        closeAllWaterIndicatorsVisible(){
            this.allWaterIndicatorsVisible = false
        },
        handleallWaterCurrentChange: function(currentPage){
            // console.log(currentPage)
            this.getEditWaterIndicators(null, null, currentPage)
        },
        editWaterIndicatorsItme(row){
            console.log(row)
        },
        getEditWaterIndicators(startTime,endTime, page=1){
            const that = this,
                query = {
                    id: that.query.id,
                    page: page,
                    start_time: startTime,
                    end_time: endTime,
                    limit: 10
                }
            apiEditWaterIndicators(query).then(res => {
                for(const i of res.data){
                    i.detect_time = this.isNumbera(i.detect_time)&&(i.detect_time + '').length===10?this.formatDate(i.detect_time*1000):'--'
                }
                that.allWaterIndicatorsData = res.data
                that.allWaterIndicatorsPage = res
            })
        },
        allWaterIndicatorsTimeSearch(){
            if(this.allWaterIndicatorsTime){
                this.getEditWaterIndicators(this.allWaterIndicatorsTime[0]/1000,this.allWaterIndicatorsTime[1]/1000)
            }else{
                this.getEditWaterIndicators(null, null)
            }
        },
        allWaterIndicatorsTimeAdd(index, row){
            this.addWaterIndicatorsTimeVisible = true
            this.formWaterIndicatorsName = "add"
            this.allWaterIndicatorsTimeData = Object.assign({}, allWaterIndicatorsTimeFormJson)
			if (index !== null) {
				this.formWaterIndicatorsName = "edit"
                apiEditWaterIndicatorsTime({id: row.id}).then(res => {
					// if(res.code === 0) {
                        console.log(res.detect_time)
                        res.detect_time = res.detect_time * 1000
                        this.allWaterIndicatorsTimeData = res
                    // }else{
					// 	this.$message({
					// 		message: res.message,
					// 		type: "error"
					// 	})
                    // }
                })
            }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) this.$refs["allWaterIndicatorsTimeForm"].clearValidate();
            
        },
        allWaterIndicatorsTimeAddClose(){
            this.addWaterIndicatorsTimeVisible = false
            this.$refs["allWaterIndicatorsTimeForm"].resetFields()
            return true;
        },
        allWaterIndicatorsTimeSubmit(){
		    this.$refs["allWaterIndicatorsTimeForm"].validate(valid => {
		        if (valid) {
		            let data = Object.assign({}, this.allWaterIndicatorsTimeData)
                    data.e_id = this.query.id
                    // let detectTime = (data.detect_time + '').length > 10 ? data.detect_time /1000 : data.detect_time

                    data.detect_time = new Date(data.detect_time).getTime()
                    waterIndicatorsSave(data, this.formWaterIndicatorsName).then(res => {
                        if (res.code === 0) {
		                    this.$message({
		                        message: "操作成功",
		                        type: "success"
		                    })
                        }else{
		                    this.$message({
		                        message: res.message,
		                        type: "error"
		                    })
                        }
                    }).then(() => {
                        this.allWaterIndicatorsTimeAddClose()
                        this.getEditWaterIndicators(null, null)
                    })
                }
            })
        },
        allWaterIndicatorsTimeDel(index, row) {
            if (row.id) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(() => {
					let para = { id: row.id };
					waterIndicatorsDelete(para).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: "删除成功",
                                type: "success"
                            });
                            // 刷新数据
                            // this.allWaterIndicatorsTimeData.splice(index, 1);
                            this.getEditWaterIndicators(null, null)
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error"
                            });
                        }
                    }).catch(() => {this.deleteLoading = false;})
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "取消删除"
                    })
                })
			}
        }
    },
    mounted() {
        setTimeout(() => {
            console.log('----------555555555555555==============')
            this.drawLine()
        },1000)
        
        
    }
};
</script>

<style lang="scss" scoped>
    .app-container{
        padding-top: 20px;
        color: #000;
    }
    .top-table{
        margin: 10px 0;
    }
    .upi-table{
        border: 1px solid #ebeef5;
        margin: 10px 0;
        .upit-td{
            border-bottom: 1px solid #ebeef5;
            height: 50px;
            display: flex;
            align-items:center;
            .upitt-label{
            display: flex;
            justify-content:center;
            align-items:center;
            height: 50px;
            width: 150px;
            background: #f5f7fa;
            text-align: center;
            border-bottom: 1px solid #ebeef5;
            }
            .upitt-value{
            display: flex;
            align-items:center;
            height: 50px;
            padding: 0 20px;
            }
        }
    }
    .el-image {
        float: left;
        margin: 8px;
    }
    .el-message-box{
        min-width: 420px;
    }
    .el-textarea {
        width: 400px;
    }
    
    .el-upload-list__item.is-success .el-upload-list__item-thumbnail {
        position: absolute;
        width: 100%;
        height: auto !important;
        top:50%;
        left:50%;-webkit-transform: translate(-50%,-50%);-o-transform: translate(-50%,-50%);transform: translate(-50%,-50%);
    }
    
    .tUserBut{
        text-align: center;
        margin: 40px 0;
    }
  .el-upload-list__item-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0,0,0,.5);
    -webkit-transition: opacity .3s;
    transition: opacity .3s
}

.el-upload-list__item-actions:after {
    display: inline-block;
    content: "";
    height: 100%;
    vertical-align: middle
}

.el-upload-list__item-actions span {
    display: none;
    cursor: pointer
}

.el-upload-list__item-actions span+span {
    margin-left: 15px
}

.el-upload-list__item-actions .el-upload-list__item-delete {
    position: static;
    font-size: inherit;
    color: inherit
}

.el-upload-list__item-actions:hover {
    opacity: 1
}

.el-upload-list__item-actions:hover span {
    display: inline-block
}

.upl-itme-icon{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    cursor:pointer;
    .icon {
        width: 148px;
        height: 148px;
        position: relative;
        border: 1px dashed #e6e6e6;
        svg{
            position:absolute;top:40%;left:50%;transform:translate(-50%,-50%);justify-content: center; align-items: center;
            width: 80%;
        }
        .text {
            position:absolute;top:65%;left:50%;transform:translate(-50%,-50%);justify-content: center; align-items: center;
            color: #000;
            font-size: 12px;
        }
    }
}
</style>